export default "__VITE_ASSET__DiV2DziO__"